import { Component, Input } from '@angular/core';
import { EapStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';

@Component({
    selector: 'app-eap-status-indicator',
    templateUrl: './eap-status-indicator.component.html',
    styleUrls: ['./eap-status-indicator.component.scss'],
    standalone: false,
})
export class EapStatusIndicatorComponent {
    @Input() isReceivingData: boolean;
    @Input() index: number;
    @Input() eap: EapStatus;

    constructor(private systemStatusService: SystemStatusService) {}

    hasAlarms(): boolean {
        if (!this.isReceivingData) return false;
        return this.systemStatusService.getAlarmCounts(this.eap) > 0;
    }

    getIcon(alarmValue: 0 | 1): string {
        if (!this.isReceivingData) return '';
        if (alarmValue === 0) {
            return 'status-error';
        } else if (alarmValue === 1) {
            return 'status-check';
        }
    }
}
